import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { Alert, Box, Stack, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { Button } from '@verantos-dev/shared-components';

import { CreateProjectSuccessModal } from './ReviewAndCreate/CreateProjectSuccessModal';
import { useWizardFooter } from './useWizardFooter';

interface WizardFooterProps {
  requiredFieldsFilled: boolean;
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}
export const WizardFooter = ({
  requiredFieldsFilled,
  setRequiredFieldsFilled,
}: WizardFooterProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    isFirstStep,
    goToPreviousStep,
    handleCreateAnnotationProject,
    goToNextStep,
    nextStep,
    isLastStep,
    isCreateAnnotationProjectLoading,
    createAnnotationProjectError,
    showCreateProjSuccessModal,
    setShowCreateProjSuccessModal,
    projName,
  } = useWizardFooter({ setRequiredFieldsFilled });

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        p: theme.spacing(4),
        position: 'sticky',
        bottom: 0,
        backgroundColor: theme.palette.background.paper,
        zIndex: 10,
        display: 'flex',
        marginTop: 'auto',
      }}
    >
      <Stack direction="row" justifyContent="space-between" width="100%">
        {isFirstStep ? (
          <Box id="placeholder-button"></Box>
        ) : (
          <Button
            startIcon={<KeyboardBackspaceIcon />}
            variant="outlined"
            id="wizard-footer-cancel-button"
            displayLabel={formatMessage({ id: 'createProjectWizard.footer.back' })}
            onClickHandler={goToPreviousStep}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
            }}
          />
        )}
        {createAnnotationProjectError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {createAnnotationProjectError}
          </Alert>
        )}

        <Stack direction="row" spacing={2}>
          {isLastStep ? (
            <Button
              startIcon={<RocketLaunchIcon />}
              variant="contained"
              id="wizard-footer-next-button"
              onClickHandler={handleCreateAnnotationProject}
              disabled={isCreateAnnotationProjectLoading}
              displayLabel={
                isCreateAnnotationProjectLoading
                  ? formatMessage({ id: 'createProjectWizard.footer.createProject.loading' })
                  : formatMessage({ id: 'createProjectWizard.footer.createProject' })
              }
              sx={{
                textTransform: 'none',
                background: theme.palette.primary.dark,
                fontSize: '14px',
              }}
            />
          ) : (
            <Button
              endIcon={<ArrowForwardIcon />}
              variant="contained"
              id="wizard-footer-next-button"
              onClickHandler={goToNextStep}
              disabled={!requiredFieldsFilled}
              displayLabel={
                formatMessage({ id: 'createProjectWizard.footer.next' }) +
                formatMessage({ id: `createProjectWizard.step.${nextStep()}.title` })
              }
              sx={{
                textTransform: 'none',
                background: theme.palette.primary.dark,
                fontSize: '14px',
              }}
            />
          )}
        </Stack>
      </Stack>
      <CreateProjectSuccessModal
        showModal={showCreateProjSuccessModal}
        setShowModal={setShowCreateProjSuccessModal}
        projName={projName}
      />
    </Box>
  );
};
